<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ser"><img alt="9781618371621_0050_001" id="d7e1508450" src="Images/9781618371621_0050_001.jpg" style="max-width:100%;"/></p>
<p class="cap" id="d7e1742951"><a href="#/Text/West_9781618371621_epub_c69_r1#d7e2313567" id="d14es45">South-of-the-Border Chicken Soup (recipe)</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c44_r1.vue?52e916c4